import React, { useState, useEffect, useContext } from 'react'
import { navigate } from 'gatsby'

import { costActivity, costActivityImage, gameId, gameIdDiversion } from '../../../constants/activity-constants'

import { siteUrl } from '../../../shared/utils/siteUrl'
import CompetitionService from '../../../shared-campaign/services/competition'
import gameServices from '../../../services/game-service'
import { Context } from '../../../context/app-context'
import AuthService from '../../../shared/services/auth-service'
import userSessionStorage from '../../../utils/userSessionStorage'

import './modalRedeem.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ModalReedem = props => {
  const { handleStartGame, close } = props

  const { dispatch } = useContext(Context)
  const [session] = useState(new userSessionStorage())
  const [pointsUser, setPointsUser] = useState('')
  const [nameUser, setNameUser] = useState('')

  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingPoints, setIsLoadingPoints] = useState(false)

  const [errorMessageKeys, setErrorMessageKeys] = useState(false)
  const [errorMessageRedeem, setErrorMessageRedeem] = useState(false)

  const [myKey, setMyKey] = useState('')

  // load user info
  useEffect(() => {
    sessionStorage.setItem('diversion', false)
    let userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
    if (userInfo) {
      setNameUser(userInfo.name.split(' ')[0])

      let tokenId = session.getToken().idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }
      AuthService.sessionInfo(config).then(res => {
        if (res.status === 200) {
          setPointsUser(
            res.data.userPoints.pointsAccumulation +
            res.data.userPoints.pointsPresent,
          )
        } else {
          setPointsUser(
            userInfo.userPoints.pointsAccumulation +
            userInfo.userPoints.pointsPresent,
          )
        }
      })
    } else {
      navigate('/')
    }
  }, [])

  const handleErrorMessage = (set, message) => {
    set === 'errorkeys'
      ? setErrorMessageKeys(message)
      : setErrorMessageRedeem(message)
    setTimeout(() => {
      setErrorMessageKeys('')
      setErrorMessageRedeem('')
    }, 6000)
  }

  const handleRedimir = (type) => {
    // type 0 without, 1 wirh points
    if (type === 1) {
      pushEventDataLayer('Personajes :: Juego', 'Click :: Jugar Para Ganar Premios', 'QUIERO REDIMIR Y JUGAR')

    } else {
      pushEventDataLayer('Personajes :: Juego', 'Click :: Jugar Para Divertirme', 'AQUÍ')

    }


    setIsLoading(true)
    setErrorMessageRedeem(false)
    let points = pointsUser
    if (points < costActivity && type === 1) {
      handleErrorMessage('errorRedeem', 'No hay suficientes puntos.')
      setIsLoading(false)
      return
    }
    let tokenId = session.getToken().idToken
    let config = {
      headers: {
        Authorization: tokenId,
      },
    }
    let idActivity = type === 0 ? gameIdDiversion : gameId
    if (type === 0) {
      sessionStorage.setItem('diversion', true)
    }

    try {
      gameServices.getTokenGame(idActivity, config).then(res => {
        if (res.status === 200) {
          sessionStorage.setItem('tokenParticipation', res.data.tokenGame)
          setIsLoading(false)
          reedemSuccess()
        } else if (res.status === 400) {
          gameServices.postGameParticipationRedeem(idActivity, config).then(res => {
            if (res.status === 200) {
              sessionStorage.setItem('tokenParticipation', res.data.tokenGame)
              setIsLoading(false)
              reedemSuccess()
            } else {
              handleErrorMessage('errorRedeem', res.userMessage)
              setIsLoading(false)
            }
          })
        } else {
          handleErrorMessage('errorRedeem', res.userMessage)
          setIsLoading(false)
        }
      })
    } catch (error) {
      console.log(error)
      handleErrorMessage(
        'errorRedeem',
        'Algo ha salido mal con la petición, inténtalo de nuevo',
      )
      setIsLoading(false)
    }
  }

  const dispatchPregame = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: `pregame`,
          props: {
            handleStartGame,
          },
        },
      },
    })
  }

  const handleUpdateData = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: `updateData`,
          props: {
            success: () => dispatchPregame(),
            close: () => {
              navigate('/')
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
          },
        },
      },
    })
  }

  const reedemSuccess = () => {
    // actulizar datos si corresponde
    let updateDAta = JSON.parse(localStorage.getItem('UPDATE_DATA_ACTIVITY'))
    const userInfo = JSON.parse(localStorage.getItem('USER_INFO')).email

    const isUpdateData =
      updateDAta &&
      updateDAta.some(item => {
        return item.email === userInfo && item.activityId === gameId
      })


    if (isUpdateData) {
      dispatchPregame()
    } else {
      handleUpdateData()
    }
  }

  const handleAquirePoints = async e => {
    e.preventDefault()
    pushEventDataLayer('Personajes :: Juego', 'Click :: Enviar Clave', 'ENVIAR')

    setIsLoadingPoints(true)

    if (myKey === '') {
      handleErrorMessage('errorkeys', 'Ingresa primero una clave')
      setIsLoadingPoints(false)
    } else {
      setErrorMessageKeys(false)
      let redeemRes = await CompetitionService.postRedeemKeyWithoutPoints(0, {
        activity: 'halloween',
        key: { code: myKey },
        country: parseInt(process.env.COUNTRY_CODE),
      })
      if (redeemRes.status === 200) {
        setIsLoadingPoints(false)
        setPointsUser(points => points + redeemRes.data.points)
        setMyKey('')
      } else {
        handleErrorMessage('errorkeys', redeemRes.userMessage)
        setIsLoadingPoints(false)
      }
    }
  }

  const formatNumber = number => {
    if (number === '0') return 0
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return
  }

  return (
    <div className='f-modalRedeem-container'>
      <div className='f-modalRedeem-container__wrapper'>
        <span className='f-modalRedeem-container__content__close' onClick={() => close()} />
        <div className='f-modalRedeem-container__content'>
          <div className='f-modalRedeem-container__content__info-user'>
            <h2 className='f-modalRedeem-container__content__info-user-name'>Hola {nameUser}, </h2>

            <p
              className='f-modalRedeem-container__content__info-user-points'>Tenés <span>{formatNumber(pointsUser)} </span>
              acumulados en NosotrasOnline.
            </p>

            <p className='f-modalRedeem-container__content__info-user-remember'>¡Recordá que esta vez podés elegir
              cómo hacerlo!</p>


          </div>
          <div className='f-modalRedeem-container__content__type-participation'>
            <div className='f-modalRedeem-container__content__type-participation-without-points'>
              <span className='border'>JUGÁ PARA DIVERTIRTE</span>
              <p>Jugá sin puntos para DIVERTIRTE </p>
              <p>*no necesitás puntos, pero no participás por el premio</p>
              <button disabled={isLoading} onClick={() => handleRedimir(0)}>ACÁ</button>
            </div>
            <div className='f-modalRedeem-container__content__type-participation-with-points'>
              <span className='border border--click' onClick={() => (
                !isLoading && handleRedimir(1)
              )}>JUGÁ PARA GANAR PREMIOS</span>
              {errorMessageRedeem && (
                <span className='f-errorMessage'>{errorMessageRedeem}</span>
              )}
              <p>
                Jugá con tus puntos y participás por el premio
              </p>

              <p className='f-modalRedeem-container__content__type-participation-with-points-image'>¡Canjeá <span><img
                src={costActivityImage} alt='puntos' /> </span> puntos!</p>

              <p><b>1 oportunidad </b> = {costActivity} puntos</p>

              <button disabled={isLoading} className='btn-redeem' onClick={() => handleRedimir(1)}>QUIERO CANJEAR Y
                JUGAR
              </button>
              {errorMessageRedeem && (
                <span className='f-errorMessage'>{errorMessageRedeem}</span>
              )}

              <p><b>¿No tenés puntos? </b> inscribí acá las claves de tus productos Nosotras y acumula puntos para
                jugar.</p>
              <input
                placeholder='Digita Tus Claves'
                value={myKey}
                onChange={e => {
                  setMyKey(e.target.value)
                }}
              />
              {errorMessageKeys && (
                <span className='f-errorMessage'>{errorMessageKeys}</span>
              )}
              <button disabled={isLoadingPoints} className='btn-redeem' onClick={(e) => handleAquirePoints(e)}>ENVIAR
              </button>


            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalReedem
